const FooterListItemSocial = ({ url, label, type }) => (
    <li className="footer-li-social" id={`footer-li-social-${type}`}>
        <a target="__blank" href={url}>
            {label}
        </a>
    </li>
)

FooterListItemSocial.propTypes = {
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
}

export default FooterListItemSocial
